export default __webpack_public_path__ + "static/media/gw200-3.e0062868.png";